import styled from 'styled-components';
export const FractalContainer = styled.div`
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
		& .nonp-carousel-container {
			& > .nonp-carousel {
				width: 100%;
				& > .nonp {
					& ul.slider {
						padding: 0 10px !important;
					}
				}
			}
		}
	}
	@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	}
	& .ff-suggest-heading {
		margin: 20px 0px;
		color: #000;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}
	& .ff-product-carousel-swap {
		& > .carousel-root {
			& > .carousel.carousel-slider {
				& > .control-dots {
					display: none;
				}
				& > .slider-wrapper {
					& > ul {
						padding: 0 !important;
						padding-right: ${(props) =>
							props.screenSize < 375 ? '23px !important' : 'initial'};
					}
				}
				& > .carouselButtons-swap {
					z-index: 1;
					position: absolute;
					border: none;
					background: none;
					&.right {
						right: ${(props) =>
							props.screenSize < 375 ? '64px !important' : 'initial'};
					}
				}
			}
		}
	}
`;
